import type { BreadcrumbItem } from "@/components/ui/breadcrumb";

export function paymentCallbackBreadcrumbs(
  invoiceType: string | null,
  digitalResourceId: string | null
): BreadcrumbItem[] {
  if (invoiceType === "digital_resource") {
    const items: BreadcrumbItem[] = [
      { label: "Dashboard", href: "/dashboard" },
      { label: "Paid Resources", href: "/paid-resources" },
    ];
    if (digitalResourceId) {
      items.push({ label: "Resource", href: `/paid-resources/${digitalResourceId}` });
    }
    items.push({ label: "Payment confirmation" });
    return items;
  }
  return [{ label: "Dashboard", href: "/dashboard" }, { label: "Payment confirmation" }];
}
